import ReactDOM from 'react-dom';
import App from './components/App';

const root = document.querySelector("#root")

ReactDOM.render(<App/>, root);